import { useFormContext } from 'react-hook-form';

import { type DraftProctorRequestEditionFormInput } from './schemas';

function useDraftProctorRequestEditionForm() {
  const context = useFormContext<DraftProctorRequestEditionFormInput>();

  if (!context) {
    throw new Error(
      'useDraftProctorRequestEditionForm must be used within a DraftProctorRequestEditionFormProvider',
    );
  }

  return context;
}

export { useDraftProctorRequestEditionForm };
